import ChangeImageOnHover from './change-image-on-hover'
import toggleScroll from './toggle-scroll'

const escButtonKeyCode = 27

const menu = {
  isOpened: false,
  init: () => {
    const menuToggle = document.querySelector('[data-menu-toggle]')

    menu.scrollable = document.querySelector('[data-menu-scrollable]')

    if (menuToggle) {
      menuToggle.addEventListener('click', () => {
        menu.toggle(!menu.isOpened)
      })
    }

    // hover images
    const imageChanger = new ChangeImageOnHover(menu.scrollable)

    // escape button - close menu, hide image

    document.documentElement.addEventListener('keydown', e => {
      if (e.keyCode === escButtonKeyCode) {
        menu.toggle(false)
        imageChanger.targetBg = null
        imageChanger.requestUpdate()
      }
    })
  },
  toggle: shouldBeOpened => {
    if (menu.isOpened === shouldBeOpened) return
    menu.isOpened = shouldBeOpened

    toggleScroll(!menu.isOpened, menu.scrollable)
    setTimeout(() => {
      document.documentElement.classList.toggle('menu-opened', menu.isOpened)
      if (menu.isOpened) {
        menu.scrollable.scrollTop = 0
      }
    }, 0)

    // iframe
    if (menu.scrollable.contentDocument) {
      const event = new CustomEvent('toggleMenu', {
        detail: { isOpened: menu.isOpened },
      })
      menu.scrollable.contentDocument.dispatchEvent(event)
    }
  },
}

export default menu
